export const cognitiveAssessmentsTranslation = {
  'cognitiveassessmentstranslations.title': 'Test kognitivnih sposobnosti',
  'cognitiveassessmentstranslations.cognitiveTestResults':
    'Rezultati testiranja kognitivnih sposobnosti',
  'cognitiveassessmentstranslations.cognitiveTestNoConsentBoxValue':
    'Rezultatov kognitivnega testiranja vam ne moremo prikazati, dokler ne podate ustreznega soglasja. To lahko storite v',
}
